module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/15-e4badfebf5fa46d2e5a33ff2294275c3.png";